// extracted by mini-css-extract-plugin
module.exports = {"container":"ChangeNotesList_container__gzmyq"};